import { Stack, Typography } from '@mui/material';
import { AnalysingLoadingGif } from 'common/animations/AnalysingLoadingGif';
import { AnalysisRequirementInput } from 'modules/analyse/types/AnalysisRequirementInput';
import { requirementsGeneratedMapper } from 'pages/CandidatesRanking/utils';
import { useEffect } from 'react';
import { generateJobRequirements } from 'services/candidate/api';
import { ToastType, useToast } from 'services/toast';

type Props = {
  jobDescription: string;
  onGenerateRequirements: (requirements: AnalysisRequirementInput[]) => void;
};

export const GenerateRequirementsStep: React.FC<Props> = ({
  jobDescription,
  onGenerateRequirements
}) => {
  const { showToast } = useToast();

  const generateRequirements = async () => {
    try {
      const { requirements } = await generateJobRequirements({
        jobDescription
      });
      const mappedRequirements = requirementsGeneratedMapper(requirements);
      onGenerateRequirements(mappedRequirements);
    } catch (e) {
      showToast({
        message: 'Something went wrong. Try again or contact support.',
        type: ToastType.Error
      });
    }
  };

  useEffect(() => {
    generateRequirements();
  }, []);

  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Stack direction="row" alignItems="center" gap={1}>
        <AnalysingLoadingGif />
        <Typography variant="heading">
          Generating requirements from job description
        </Typography>
      </Stack>
    </Stack>
  );
};
